import client from '../httpClient';

const calendarDownloadCSVApi = () => {
  return client.get('/calendars/csv-download/', { contentType: 'arraybuffer' });
};

export default calendarDownloadCSVApi;
